import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'

const C = { border: '#E1E5E3', ink2: '#6D7471' }
const FB = "'Inter', sans-serif"

interface Props {
  style?: React.CSSProperties
}

/** Botón que parece barra de búsqueda — lleva a /search, la página con el input real. */
export default function SearchBar({ style }: Props) {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate('/search')}
      style={{
        width: '100%',
        maxWidth: 680,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: '#F1F3F2',
        border: `1px solid ${C.border}`,
        borderRadius: 12,
        padding: '11px 16px',
        cursor: 'pointer',
        fontFamily: FB,
        ...style,
      }}
    >
      <Search size={17} color={C.ink2} />
      <span style={{ color: C.ink2, fontSize: 14.5 }}>Busca lugares, promociones, eventos…</span>
    </button>
  )
}
